import { render, staticRenderFns } from "./FooterRock.vue?vue&type=template&id=b9a6a4a0&"
import script from "./FooterRock.vue?vue&type=script&lang=js&"
export * from "./FooterRock.vue?vue&type=script&lang=js&"
import style0 from "./FooterRock.vue?vue&type=style&index=0&id=b9a6a4a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports